/**
 * Shopify support form → POST /api/shopify/support-salesforce
 * Does not use React POST /api/support-salesforce.
 */
(function () {
  var MAX_FILE_BYTES = 5 * 1024 * 1024;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function fileToBase64(file) {
    return new Promise(function (resolve, reject) {
      var reader = new FileReader();
      reader.onload = function () {
        var result = String(reader.result || '');
        var comma = result.indexOf(',');
        resolve(comma >= 0 ? result.slice(comma + 1) : result);
      };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }

  function showToast(title, description, isError) {
    var existing = document.querySelector('.ll-support__toast');
    if (existing) existing.remove();

    var toast = document.createElement('div');
    toast.className = 'll-support__toast' + (isError ? ' ll-support__toast--error' : '');
    toast.setAttribute('role', 'status');
    toast.innerHTML =
      '<p class="ll-support__toast-title"></p><p class="ll-support__toast-body"></p>';
    toast.querySelector('.ll-support__toast-title').textContent = title;
    toast.querySelector('.ll-support__toast-body').textContent = description;
    document.body.appendChild(toast);
    setTimeout(function () {
      if (toast.parentNode) toast.parentNode.removeChild(toast);
    }, 5000);
  }

  function interpolate(template, fileName) {
    return String(template || '')
      .replace(/\{\{\s*fileName\s*\}\}/g, fileName)
      .replace(/%s/g, fileName);
  }

  ready(function () {
    var cfg = window.LLSupportSalesforce || {};
    var form = document.getElementById('LLSupportForm');
    if (!form) return;

    var i18n = cfg.i18n || {};
    var attachments = [];
    var fileInput = form.querySelector('[data-ll-support-files]');
    var attachBtn = form.querySelector('[data-ll-support-attach]');
    var chips = form.querySelector('[data-ll-support-chips]');
    var submitBtn = form.querySelector('[data-ll-support-submit]');
    var statusEl = document.querySelector('[data-ll-support-status]');

    function setStatus(message, kind) {
      if (!statusEl) return;
      statusEl.hidden = !message;
      statusEl.textContent = message || '';
      statusEl.className =
        'll-support__status' + (kind ? ' ll-support__status--' + kind : '');
    }

    function setFieldError(name, message) {
      var el = form.querySelector('[data-error-for="' + name + '"]');
      if (!el) return;
      el.hidden = !message;
      el.textContent = message || '';
    }

    function clearErrors() {
      ['reference_number', 'email', 'category', 'subject', 'description'].forEach(function (name) {
        setFieldError(name, '');
      });
      setStatus('', '');
    }

    function renderChips() {
      if (!chips) return;
      chips.innerHTML = '';
      attachments.forEach(function (file, index) {
        var chip = document.createElement('div');
        chip.className = 'll-support__chip';
        var name = document.createElement('span');
        name.className = 'll-support__chip-name';
        name.textContent = file.name;
        var remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'll-support__chip-remove';
        remove.setAttribute('aria-label', interpolate(i18n.removeAttachment, file.name));
        remove.innerHTML =
          '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>';
        remove.addEventListener('click', function () {
          attachments.splice(index, 1);
          renderChips();
        });
        chip.appendChild(name);
        chip.appendChild(remove);
        chips.appendChild(chip);
      });
    }

    function setSubmitting(on) {
      if (!submitBtn) return;
      var textEl = submitBtn.querySelector('[data-ll-support-submit-text]');
      var iconEl = submitBtn.querySelector('svg');
      var spinnerEl = submitBtn.querySelector('[data-ll-support-spinner]');
      submitBtn.disabled = on;
      submitBtn.setAttribute('aria-busy', on ? 'true' : 'false');
      if (textEl) {
        textEl.textContent = on
          ? submitBtn.getAttribute('data-label-busy') || 'Submitting...'
          : submitBtn.getAttribute('data-label-idle') || 'Submit Support Case';
      }
      if (iconEl) iconEl.style.display = on ? 'none' : '';
      if (on && !spinnerEl) {
        spinnerEl = document.createElement('span');
        spinnerEl.className = 'll-support__spinner';
        spinnerEl.setAttribute('data-ll-support-spinner', '');
        spinnerEl.setAttribute('aria-hidden', 'true');
        submitBtn.insertBefore(spinnerEl, submitBtn.firstChild);
      } else if (!on && spinnerEl) {
        spinnerEl.parentNode.removeChild(spinnerEl);
      }
    }

    if (attachBtn && fileInput) {
      attachBtn.addEventListener('click', function () {
        fileInput.click();
      });
    }

    if (fileInput) {
      fileInput.addEventListener('change', function () {
        var files = fileInput.files;
        if (!files || !files.length) return;

        var jobs = [];
        for (var i = 0; i < files.length; i++) {
          (function (file) {
            if (file.size > MAX_FILE_BYTES) {
              showToast(
                i18n.fileTooLargeTitle || 'File too large',
                interpolate(i18n.fileTooLargeDescription, file.name),
                true
              );
              return;
            }
            jobs.push(
              fileToBase64(file).then(function (data) {
                attachments.push({ name: file.name, data: data, size: file.size });
              })
            );
          })(files[i]);
        }

        Promise.all(jobs).then(function () {
          renderChips();
          fileInput.value = '';
        });
      });
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      clearErrors();

      if (!cfg.enabled || !cfg.url) {
        showToast(
          i18n.errorTitle || 'Submission Failed',
          i18n.errorDescription || 'Failed to submit support request. Please try again.',
          true
        );
        return;
      }

      var reference = (form.reference_number.value || '').trim();
      var email = (form.email.value || '').trim();
      var category = form.category.value || '';
      var subject = (form.subject.value || '').trim();
      var description = (form.description.value || '').trim();
      var valid = true;

      if (!reference) {
        setFieldError('reference_number', i18n.referenceRequired);
        valid = false;
      }
      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        setFieldError('email', i18n.invalidEmail);
        valid = false;
      }
      if (!category) {
        setFieldError('category', i18n.categoryRequired);
        valid = false;
      }
      if (!subject) {
        setFieldError('subject', i18n.subjectRequired);
        valid = false;
      }
      if (!description) {
        setFieldError('description', i18n.descriptionRequired);
        valid = false;
      }
      if (!valid) return;

      setSubmitting(true);

      var payload = {
        reference_number: reference,
        email: email,
        category: category,
        subject: subject,
        description: description,
        attachments: attachments.map(function (file) {
          return { fileName: file.name, fileData: file.data };
        }),
      };

      fetch(cfg.url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify(payload),
        mode: 'cors',
      })
        .then(function (response) {
          return response.json().then(function (result) {
            return { ok: response.ok, result: result };
          });
        })
        .then(function (pack) {
          var result = pack.result || {};
          if (result.success) {
            form.reset();
            attachments = [];
            renderChips();
            setStatus(i18n.successDescription, 'success');
            showToast(i18n.successTitle, i18n.successDescription, false);
            return;
          }
          throw new Error(result.message || i18n.genericError);
        })
        .catch(function (error) {
          var message = (error && error.message) || i18n.errorDescription;
          setStatus(message, 'error');
          showToast(i18n.errorTitle, message, true);
        })
        .finally(function () {
          setSubmitting(false);
        });
    });
  });
})();
